"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isNode = require("detect-node");
var Logger = isNode ? require('./NodeLogger').default : require('./BrowserLogger').default;
exports.default = Logger;
var LogLevel_1 = require("./LogLevel");
exports.LogLevel = LogLevel_1.default;
//# sourceMappingURL=index.js.map